/**
 * The single error type of the platform client. `problem` is always present: it is the server's
 * problem document when the body was one, and a synthesized document otherwise, so callers can
 * always switch on `error.code`.
 */
export class PlatformApiError extends Error {
    name = 'PlatformApiError';
    kind;
    /** HTTP status, or 0 when no response arrived. */
    status;
    problem;
    /** The x-correlation-id this client sent, for support and log lookups. */
    correlationId;
    /** The contract route template that failed (for example /v1/navigation/decide). */
    route;
    constructor(init) {
        super(`${init.route}: ${init.problem.title} (${init.status || init.kind})`, { cause: init.cause });
        this.kind = init.kind;
        this.status = init.status;
        this.problem = init.problem;
        this.correlationId = init.correlationId;
        this.route = init.route;
    }
    get code() {
        return this.problem.code;
    }
}
export function isPlatformApiError(value) {
    return value instanceof PlatformApiError;
}
/** Maps an HTTP status to the closest contract error code when the body carried no problem document. */
export function codeForStatus(status) {
    if (status === 0)
        return 'dependency_unavailable';
    if (status === 400)
        return 'bad_request';
    if (status === 401)
        return 'unauthenticated';
    if (status === 403)
        return 'forbidden';
    if (status === 404)
        return 'not_found';
    if (status === 409)
        return 'conflict';
    if (status === 412)
        return 'precondition_failed';
    if (status === 422)
        return 'validation_failed';
    if (status === 429)
        return 'rate_limited';
    if (status === 502 || status === 503 || status === 504)
        return 'dependency_unavailable';
    if (status >= 500)
        return 'internal';
    return 'bad_request';
}
export function synthesizedProblem(status, title, code = codeForStatus(status)) {
    return { type: 'about:blank', title, status, code };
}
//# sourceMappingURL=errors.js.map